import { defineBlock } from "eddev/blocks"
import { Container, Grid, Col } from "@components/layout/Grid"
import { CardMoreInfo } from "@components/molecules/Cards"

export const meta: BlockMeta = {
  title: "Child pages",
  category: "common",
  icon: "editor-ul",
  keywords: ["child", "children"],
  tags: ["root"],
  editMode: "preview",
  lazyLoad: false,
  conditions: {
    postTypes: ["page", "post"],
    multiple: false,
  },
}

export default defineBlock("general/child-pages", (props) => {
  console.log(props)
  return (
    <Container className="my-4">
      <Grid>
        {props.page?.children?.nodes.map((child, i) => {
          if (child.__typename !== "Page") return <></>
          console.log(child)

          return (
            <Col initial={12} key={i}>
              <CardMoreInfo
                type="sibling"
                ancestor={{
                  uri: props.page!.uri!,
                  title: props.page!.title!,
                }}
                title={child.title!}
                heading={child.nextHeading ?? undefined}
                content={child.excerpt ? child.excerpt : child.nextContent ? child.nextContent : undefined}
                image={child.nextHeroimage ?? undefined}
                link={child.uri!}
                buttonTextOverride={
                  child.pageOptions?.buttonTextOverride ? child.pageOptions?.buttonTextOverride : undefined
                }
              />
            </Col>
          )
        })}
      </Grid>
    </Container>
  )
})
